export interface ISort {
    ColumnID: number | Long;
    Desc: boolean;
}

export type SortProps = {
    ColumnID: number | Long;
    Desc: boolean;
};
export class Sort implements ISort {
    public ColumnID: number | Long;
    public Desc: boolean;

    constructor(properties?: SortProps) {
        this.ColumnID = properties?.ColumnID;
        this.Desc = properties?.Desc;
    }
}
